import React from 'react';

const Values = () => {
  const values = [
    {
      number: "01",
      title: "Efficiency",
      description: "Streamlined, time-sensitive solutions that are cost-effective and aligned with client objectives.",
      points: [
        "Cost-effective solutions",
        "Time-sensitive delivery",
        "Client-aligned objectives",
        "Streamlined processes",
        "Optimal resource utilization"
      ]
    },
    {
      number: "02",
      title: "Partnership",
      description: "Building enduring, transparent, and mutually beneficial relationships with all stakeholders.",
      points: [
        "Mutually beneficial relationships",
        "Transparent communication",
        "Enduring partnerships",
        "Stakeholder collaboration",
        "Shared success focus"
      ]
    },
    {
      number: "03",
      title: "Convenience",
      description: "Simplifying procurement and supply chain processes with accessible, reliable, and integrated services.",
      points: [
        "Simplified processes",
        "Accessible services",
        "Reliable delivery",
        "Integrated solutions",
        "User-friendly approach"
      ]
    },
    {
      number: "04",
      title: "Innovation",
      description: "Continuously improving offerings and developing cutting-edge solutions for evolving client needs.",
      points: [
        "Continuous improvement",
        "Cutting-edge solutions",
        "Future-focused approach",
        "Adaptive strategies",
        "Technology integration"
      ]
    }
  ];

  return (
    <section id="values" className="values-section">
      <div className="container">
        <div className="values-header">
          <h1>Core Business Values</h1>
        </div>

        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card-modern">
              <div className="value-number">{value.number}</div>
              <div className="value-content">
                <h3>{value.title}</h3>
                <p className="value-description">{value.description}</p>
                <ul className="value-points">
                  {value.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>                
      </div>
    </section>
  );
};

export default Values;